import { Link } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

export function NotFound() {
	return (
		<div className="flex min-h-[70vh] flex-col items-center justify-center bg-background px-4 py-16 text-center">
			<div className="mx-auto max-w-md space-y-6">
				<div className="space-y-2">
					<h1 className="font-display text-7xl font-bold text-primary">404</h1>
					<h2 className="font-display text-2xl font-semibold text-foreground">
						Страницата не е пронајдена
					</h2>
				</div>
				<p className="text-muted-foreground">
					Страницата што ја барате не постои или е преместена. Ве молиме
					проверете го URL или се вратете на почетната страна.
				</p>
				<div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
					<Button asChild variant="default">
						<Link to="/">Почетна</Link>
					</Button>
					<Button asChild variant="outline">
						<Link to="/contact">Контакт</Link>
					</Button>
				</div>
			</div>
		</div>
	);
}

export function DefaultError({
	error,
	reset,
}: {
	error: Error;
	reset: () => void;
}) {
	return (
		<div className="flex min-h-[70vh] flex-col items-center justify-center bg-background px-4 py-16 text-center">
			<div className="mx-auto max-w-md space-y-6">
				<div className="space-y-2">
					<div className="mx-auto flex size-20 items-center justify-center rounded-full bg-destructive/10">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
							className="size-10 text-destructive"
						>
							<title>Error icon</title>
							<circle cx="12" cy="12" r="10" />
							<path d="m15 9-6 6" />
							<path d="m9 9 6 6" />
						</svg>
					</div>
					<h1 className="font-display text-3xl font-bold text-foreground">
						Се случи грешка
					</h1>
				</div>
				<p className="text-muted-foreground">
					Се појави неочекувана грешка при вчитување на страницата. Ве молиме
					обидете се повторно.
				</p>
				{error.message && (
					<p className="rounded-md bg-muted px-4 py-2 text-sm text-muted-foreground">
						{error.message}
					</p>
				)}
				<div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
					<Button onClick={reset}>Обидете се повторно</Button>
					<Button asChild variant="outline">
						<Link to="/">Почетна</Link>
					</Button>
				</div>
			</div>
		</div>
	);
}
